import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../Style/BrandsSlider.css";

function BrandsSlider() {
  return (
    <div className="brands-bg py-4">
      <div className="overflow-hidden">
        <div className="d-flex brands-slider align-items-center">
          {/* تكرارات كافية علشان يملوا الشاشة */}
          <i className="bi bi-facebook"></i>
          <i className="bi bi-google"></i>
          <i className="bi bi-twitter-x"></i>
          <i className="bi bi-github"></i>
          <i className="bi bi-dribbble"></i>
          <i className="bi bi-facebook"></i>
          <i className="bi bi-google"></i>
          <i className="bi bi-twitter-x"></i>
          <i className="bi bi-github"></i>
          <i className="bi bi-dribbble"></i>
          <i className="bi bi-facebook"></i>
          <i className="bi bi-google"></i>
          <i className="bi bi-facebook"></i>
          <i className="bi bi-google"></i>
          <i className="bi bi-twitter-x"></i>
          <i className="bi bi-github"></i>
          <i className="bi bi-dribbble"></i>
          <i className="bi bi-facebook"></i>
          <i className="bi bi-google"></i>
          <i className="bi bi-twitter-x"></i>
          <i className="bi bi-github"></i>
          <i className="bi bi-dribbble"></i>
          <i className="bi bi-facebook"></i>
          <i className="bi bi-google"></i>
        </div>
      </div>
    </div>
  );
}

export default BrandsSlider;
